import { render, staticRenderFns } from "./editDistributionPromoterParentCode.vue?vue&type=template&id=04cd8fb8&scoped=true&"
import script from "./editDistributionPromoterParentCode.vue?vue&type=script&lang=js&"
export * from "./editDistributionPromoterParentCode.vue?vue&type=script&lang=js&"
import style0 from "./editDistributionPromoterParentCode.vue?vue&type=style&index=0&id=04cd8fb8&scoped=true&lang=css&"
import style1 from "./editDistributionPromoterParentCode.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cd8fb8",
  null
  
)

export default component.exports